module.exports = __webpack_public_path__ + "img/6da5c67.jpg";